import { render, staticRenderFns } from "./address-dialog.vue?vue&type=template&id=53b10cf3&scoped=true"
import script from "./address-dialog.vue?vue&type=script&lang=js"
export * from "./address-dialog.vue?vue&type=script&lang=js"
import style0 from "./address-dialog.vue?vue&type=style&index=0&id=53b10cf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b10cf3",
  null
  
)

export default component.exports